<template>
  <b-alert show variant="danger">Sorry, you do not have access to the resource</b-alert>
</template>
<script>
  export default {
    name: 'forbidden'
  }
</script>



// WEBPACK FOOTER //
// src/components/user/Forbidden.vue